// SE - FIX: Harden free sample behavior and add validation fallback
const optionsFreeSample = {
  section: "free_sample",
  selector: ".hc-free-sample",
};
let freeSampleSelector = document.querySelector(optionsFreeSample.selector);

const getDataFreeSample = () => {
  if (!freeSampleSelector) {
    // SE - FIX: Nothing to do if container is absent
    return Promise.resolve();
  }
  return fetch(
    window.Shopify.routes.root + `?sections=${optionsFreeSample.section}`
  )
    .then((res) => res.json())
    .then((data) => {
      const div = document.createElement("div");
      div.innerHTML = data[optionsFreeSample.section];
      const wrapper = div.querySelector(".hc-wrapper");
      freeSampleSelector.innerHTML = "";
      if (wrapper) {
        freeSampleSelector.append(wrapper);
      }
    });
};
const debounce = (func, timeout = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};
const fetchUpdate = (attributes) => {
  let params = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ attributes }),
  };
  fetch("/cart/update.js", params).then((res) => res.json());
};

// SE - FIX: Ensure default attribute value is set to "no" when absent or blank
let defaultAttributeEnsured = false;
const ensureDefaultFreeSampleAttribute = () => {
  if (defaultAttributeEnsured) return Promise.resolve();
  return fetch("/cart.js")
    .then((res) => res.json())
    .then((data) => {
      const current = data && data.attributes ? data.attributes["Free sample"] : undefined;
      if (current === undefined || current === null || current === "") {
        defaultAttributeEnsured = true;
        return fetchUpdate({ "Free sample": "no" });
      }
      defaultAttributeEnsured = true;
      return undefined;
    })
    .catch(() => {
      // swallow errors; do not block cart rendering
      defaultAttributeEnsured = true;
    });
};
const updateCartAttributes = (param) => {
  const inputs = [...document.querySelectorAll('.hc-body input[type="text"]')];

  let attributes = {};
  inputs.forEach((input) => {
    attributes[input.dataset.value] = param === "yes" ? input.value : "";
    // SE - FIX: Persist explicit "no" instead of blank when user selects No
    attributes["Free sample"] = param === "yes" ? "yes" : "no";
    input.value = param === "yes" ? input.value : "";
    input.addEventListener(
      "keyup",
      debounce((evt) => {
        attributes[evt.target.dataset.value] = evt.target.value;
        fetchUpdate(attributes);
      })
    );
  });
  fetchUpdate(attributes);
};

// SE - FIX: Validation guard for apps that bypass native form validation
let validationGuardInitialized = false;
const initCheckoutValidationGuard = () => {
  if (validationGuardInitialized) return;
  validationGuardInitialized = true;

  const form = document.getElementById("CartPageForm");
  const checkoutButton = document.querySelector(".cart__checkout");
  if (!form || !checkoutButton) return;

  const getState = () => {
    const yesRadio = document.querySelector('.hc-input-radio[value="yes"]');
    const requiredInput = document.querySelector('.hc-body input[type="text"]');
    return {
      yesSelected: !!(yesRadio && yesRadio.checked),
      requiredInput,
    };
  };

  const updateButtonState = () => {
    const { yesSelected, requiredInput } = getState();
    if (yesSelected && requiredInput) {
      const empty = !requiredInput.value || requiredInput.value.trim() === "";
      checkoutButton.disabled = empty;
    } else {
      checkoutButton.disabled = false;
    }
  };

  form.addEventListener("submit", (e) => {
    const { yesSelected, requiredInput } = getState();
    if (yesSelected && requiredInput && (!requiredInput.value || requiredInput.value.trim() === "")) {
      e.preventDefault();
      e.stopPropagation();
      requiredInput.setAttribute("required", true);
      requiredInput.focus();
    }
  }, true);

  checkoutButton.addEventListener("click", (e) => {
    const { yesSelected, requiredInput } = getState();
    if (yesSelected && requiredInput && (!requiredInput.value || requiredInput.value.trim() === "")) {
      e.preventDefault();
      e.stopPropagation();
      requiredInput.setAttribute("required", true);
      requiredInput.focus();
    }
  }, true);

  document.addEventListener("input", (evt) => {
    if (evt.target && evt.target.matches('.hc-body input[type="text"]')) {
      updateButtonState();
    }
  });

  document.addEventListener("click", (evt) => {
    if (evt.target && evt.target.classList && evt.target.classList.contains("hc-input-radio")) {
      // Defer update after radio state changes
      setTimeout(updateButtonState, 0);
    }
  });

  // Initial state
  updateButtonState();
};
const customEvents = () => {
  const bodySampleSelector = freeSampleSelector && freeSampleSelector.querySelector ? freeSampleSelector.querySelector(".hc-body") : null;
  const requiredInput = bodySampleSelector ? bodySampleSelector.querySelector('input[type="text"]') : null;
  const tooltip = freeSampleSelector ? freeSampleSelector.querySelector(".hc-tooltip") : null;
  const currentRadio = freeSampleSelector ? freeSampleSelector.querySelector(
    ".hc-input-radio:checked"
  ) : null;
  if (currentRadio && currentRadio.value === "yes") {
    updateCartAttributes("yes");
  }

  if (tooltip) {
    tooltip.addEventListener("click", function () {
      this.classList.add("hc-active");
    });
  }

  window.addEventListener("click", function (evt) {
    if (evt.target.classList && evt.target.classList.contains("hc-input-radio")) {
      let value = evt.target.value;
      if (value === "yes") {
        if (bodySampleSelector) bodySampleSelector.classList.remove("hide");
        if (requiredInput) requiredInput.setAttribute("required", true);
        updateCartAttributes("yes");
        return;
      }
      if(value === "no"){
        console.log(value)
        if (bodySampleSelector) bodySampleSelector.classList.add("hide");
        if (requiredInput) requiredInput.removeAttribute("required");
     
      fetch("/cart.js")
        .then((res) => res.json())
        .then((data) => {
          if (data.attributes) {
            let attributes = {};
            Object.keys(data.attributes).forEach((key) => {
              attributes[key] = "";
            });
            // SE - FIX: Ensure explicit "no" persists for Free sample
            attributes["Free sample"] = "no";
            fetchUpdate(attributes);
            if (bodySampleSelector) {
              let inputs = [...bodySampleSelector.querySelectorAll('input[type="text"]')];
              inputs.forEach(input => input.value = '')
            }
          }
        });
      return;
      }
      
    }
    if (evt.target.classList && evt.target.classList.contains("hc-close")) {
      if (tooltip) tooltip.classList.remove("hc-active");
    }
  });
  // SE - FIX: Initialize checkout validation fallback
  initCheckoutValidationGuard();
};
document.addEventListener("page:loaded", function () {
  // Re-query container in case DOM was not ready at script parse
  freeSampleSelector = document.querySelector(optionsFreeSample.selector);
  ensureDefaultFreeSampleAttribute().then(() => {
    getDataFreeSample().then(() => customEvents());
  });
});
document.addEventListener("cart:updated", function (evt) {
  getDataFreeSample().then(() => customEvents());
});
document.addEventListener('invalid', (function () {
  return function (e) {
    e.preventDefault();
    e.target.focus();
  };
})(), true);